import { useEffect } from 'react';
import { pushDatalayer } from 'js/utilities';

export default function ConversionFlowDatalayer({ flow, activeStepId, datalayerData = {} }) {
    useEffect(() => {
        const activeStep = flow?.steps?.find(step => step.id === activeStepId) || null;
        if (!activeStep) return;

        const datalayer = {
            form_step: activeStep.last ? 'voltooid' : `${activeStep?.position}`,
            form_id: `flow-${flow?.flowId}`,
            form_name: `${flow?.summary?.datalayer?.form_name}`,
            form_category: `${flow?.summary?.datalayer?.form_category || ''}`,
            form_type: `${flow?.summary?.datalayer?.form_type || ''}`,
            form_priority: `${flow?.summary?.datalayer?.form_priority || ''}`,
            event: (activeStep.last && flow?.summary?.datalayer?.form_priority === 'primair') ? 'purchase_leadgen' : 'form',
            ...datalayerData,
        }

        if (flow?.summary?.datalayer?.accessories_items && flow.summary.datalayer.accessories_items.length > 0) {
            Object.assign(datalayer, {
                ecommerce: {
                    currency: 'EUR',
                    value: flow.summary.datalayer.accessories_total_price,
                    items: flow.summary.datalayer.accessories_items,
                }
            });
        }

        if (flow?.summary?.datalayer?.appointment_date && flow?.summary?.datalayer?.appointment_date !== '') {
            datalayer.appointment_date = flow.summary.datalayer.appointment_date;
        }

        if (flow?.summary?.datalayer?.appointment_time && flow?.summary?.datalayer?.appointment_time !== '') {
            datalayer.appointment_time = flow.summary.datalayer.appointment_time;
        }

        if (flow?.summary?.datalayer?.maintenance_contract && flow?.summary?.datalayer?.maintenance_contract !== '') {
            datalayer.maintenance_contract = flow.summary.datalayer.maintenance_contract;
        }

        if (flow?.summary?.datalayer?.insurance && flow?.summary?.datalayer?.insurance !== '') {
            datalayer.insurance = flow.summary.datalayer.insurance;
        }

        if (flow?.summary?.datalayer?.purchase_type && flow?.summary?.datalayer?.purchase_type !== '') {
            datalayer.purchase_type = flow.summary.datalayer.purchase_type;
        }

        if (flow?.summary?.datalayer?.purchase_amount) {
            datalayer.purchase_amount = flow.summary.datalayer.purchase_amount;
        }

        if (flow?.summary?.datalayer?.trade_in_value) {
            datalayer.trade_in_value = flow.summary.datalayer.trade_in_value;
        }

        if (flow?.summary?.datalayer?.credit_amount) {
            datalayer.credit_amount = flow.summary.datalayer.credit_amount;
        }

        if (flow?.summary?.datalayer?.final_payment) {
            datalayer.final_payment = flow.summary.datalayer.final_payment;
        }

        if (flow?.summary?.datalayer?.loan_term_months) {
            datalayer.loan_term_months = flow.summary.datalayer.loan_term_months;
        }

        if (activeStep.last) {
            Object.assign(datalayer, {
                customer_email: (flow?.summary?.datalayer?.email && flow?.summary?.datalayer?.email !== '') ? flow?.summary?.datalayer?.email : null,
                phone_number: (flow?.summary?.datalayer?.phone && flow?.summary?.datalayer?.phone !== '') ? flow?.summary?.datalayer?.phone : null,
            });
        }

        pushDatalayer(datalayer);
    }, [activeStepId]);

    return null;
}
